import { IRootGizmoData, TJsonData } from '../../../types';
import { IGizmo } from '../../../types';
import { gnov, snov } from '../../../utils';

interface IParams {
  config: IGizmo;
  jsonData: TJsonData;
}

/**
 * Converts json data to Flowy format
 *
 * @param {IGizmo} config root gizmo config
 * @param {TJsonData} jsonData json data to be converted to Flowy format
 *
 * @returns {IRootGizmoData} root gizmo data in Flowy format
 */
function jsonToFlowy({ config, jsonData }: IParams): IRootGizmoData {
  const rootGizmoData: IRootGizmoData = {
    // fid: uuid(),
    fid: config.fid,
    rootGizmoFid: config.fid,
    rootGizmoVersion: config.version!,
    version: 1,
    d: {},
    j: jsonData,
  };

  if (config.gizmos) {
    for (const gizmo of config.gizmos) {
      if (gizmo.ops?.json?.path) {
        const path = gizmo.ops.json.path;
        const value = gnov(jsonData, path);

        if (value !== undefined) {
          snov(rootGizmoData, `d.${gizmo.fid}.v`, value);
        }
      }
    }
  }

  return rootGizmoData;
}

export default jsonToFlowy;
